module.exports = __webpack_public_path__ + "img/arrow-down-circle.3882cfbd.svg";